import { createFileRoute } from "@tanstack/react-router";
import { EulaContent } from "@/components/legal/eula";
import { Language } from "@linqx/i18n";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/eula")({
  head: () => ({
    meta: seo({
      title: Language.getKey("landing_meta_eula_title"),
      description: Language.getKey("landing_meta_eula_description"),
      url: "https://getlinqx.com/eula",
    }),
  }),
  component: EulaContent,
});
